import mapValues from '../utils/mapValues'

const percent = obj => mapValues(obj, v => v + '%')

export default percent
